




import businessAlliance from "../businessModules/businessAlliance.vue";
import businessMarketservice from "../businessModules/businessMarketservice.vue";
// 企业端pc模板
export default {
  name: "enterprise-businessTemplate-pc",
  components: {
    businessAlliance,
    businessMarketservice,
  },
  computed: {
    currentComponent() {
      console.log((this as any).$attrs, "this.$attrs init22");
      interface IbusinessTypeObj {
        [propName: string]: any;
      }
      const businessTypeObj: IbusinessTypeObj = {
        alliancePlatformPc: "businessAlliance",
        marketingServicePc: "businessMarketservice",
      };
      return businessTypeObj[(this as any).$attrs.config.configIdentify];
    },
  },
};
